import React, { useEffect, useMemo } from "react";
import "./Banner.css";
import { AllBanner } from "../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { IDS } from "../../utils/IDS";

function Banner() {
  const dispatch = useDispatch();
  const banners = useSelector((state) => state.common.all_banners);

  useEffect(() => {
    dispatch(AllBanner());
  }, [dispatch]);

  // 🎯 Pick a random banner whenever banners change
  const randomBanner = useMemo(() => {
    if (!banners || banners.length === 0) return null;

    const randomIndex = Math.floor(Math.random() * banners.length);
    return banners[randomIndex];
  }, [banners]);

  return (
    <div className="img_holder">
      {randomBanner ? (
        <img
          src={IDS.IMG_URL + randomBanner.image}
          alt="Banner"
          className="myImage"
        />
      ) :
        <img
          src="/Assets/Images/Banner/billing_app_banner.png"
          alt="Banner"
          className="myImage"
        />}
    </div>
  );
}

export default Banner;
